import React from "react";

const isDebug = process.env.REACT_APP_DEBUG === "true";

const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
const host = typeof window !== "undefined" ? window.location.hostname : "";
const apiUrl = process.env.REACT_APP_BACKEND_URL || "N/A";

function DebugBanner() {
  if (!isDebug) return null;

  return (
    <div
      style={{
        background: "#e74c3c",
        color: "#fff",
        padding: "5px",
        textAlign: "center",
        fontSize: "0.9em",
        fontFamily: "sans-serif",
      }}
    >
      Entorno: {environment} | Host: {host} | API URL: {apiUrl}
    </div>
  );
}

export default DebugBanner;
